import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035d16d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "onClick", "innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", {
    id: "fcb-breadcrumb",
    ref: "breadcrumb",
    class: _normalizeClass({'is-mobile': _ctx.isMobile}),
    "aria-label": "breadcrumb"
  }, [
    _createElementVNode("ol", {
      class: _normalizeClass([{'open': _ctx.mobileOpen}, "breadcrumb"]),
      start: "0"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navEntries, (navEntry) => {
        return (_openBlock(), _createElementBlock("li", {
          key: navEntry.alias,
          class: _normalizeClass([{ 'summary': navEntry.alias === 'summary', 'active': _ctx.isActiveState(navEntry), 'flash': navEntry.alias === 'summary' && _ctx.flashActive}, "breadcrumb-item"])
        }, [
          (_ctx.currentPathSegment !== navEntry.segment && navEntry.alias !== 'summary')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `#${navEntry.alias}`,
                class: "breadcrumb-link",
                onClick: ($event: any) => (_ctx.onSegmentLinkClick($event, navEntry)),
                innerHTML: _ctx.decodeHtmlEntities(navEntry.title)
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                innerHTML: _ctx.decodeHtmlEntities(navEntry.title)
              }, null, 8, _hoisted_2))
        ], 2))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{'show': _ctx.isMobile && _ctx.flashActive }, "price-popup"])
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.currentCalculatedPriceForDisplay), 1)
    ], 2)
  ], 2))
}